import BulkMessageModalAbstract from './bulk-message-modal-abstract';
import guestlistFieldValueTransformer from '../../../../guestlists/helpers/guestlist-field-value-transformer';

export default class RsvpBulkMessageModalController extends BulkMessageModalAbstract {
    constructor($uibModalInstance, $injector, $scope, extendedInformation) {
        super($uibModalInstance, $injector, $scope, extendedInformation);
        this.guestlist = _.get(extendedInformation, 'guestlist', null);
        this.supportsShowMoreOnPopOver = true;
    }

    _loadRecipientPopOverInformation(recipient) {
        this.api
            .get(`rsvps/${recipient.id}?include=guestlist,contact`)
            .then(({data}) => {
                const rsvp = data.data,
                    contact = rsvp.contact.data,
                    guestlist = rsvp.guestlist.data;

                recipient.popOverInformation.loading = false;
                const newData = {
                    'Code': rsvp.code,
                    'Status': rsvp.status,
                    'Pax planned': rsvp.pax_planned,
                    'Pax actual': rsvp.pax_actual
                };

                _.each(guestlist.enabled_fields, (fields, groupKey) => {
                    _.each(fields, (field, fieldKey) => {
                        newData[field.label] = guestlistFieldValueTransformer(
                            _.get(groupKey === 'contact' ? contact : rsvp, fieldKey),
                            field,
                            this.injector
                        );
                    })
                })

                recipient.popOverInformation.data = newData;
            })
    }

    _getParametersForTemplatesStore() {
        const scopedGuestlists = [];
        if (this.guestlist) {
            scopedGuestlists.push(this.guestlist.id);
        }
        return {
            ...super._getParametersForTemplatesStore(),
            scopedGuestlists,
            onlyScoped: scopedGuestlists.length > 0
        };
    }

    _formatDisplayRow(row, index) {
        return {
            ...super._formatDisplayRow(row, index),
            name: row.contact.full_name ? row.contact.full_name : row.contact.company_name,
            company: (_.isUndefined(row.contact.company_name) ? '' : row.contact.company_name) + '',
            image_url: row.contact.profile_image.thumbnail,
            email: row.contact.preferred_email
        };
    }

    _getDisplayStoreFields() {
        return [
            'id',
            'contact.full_name',
            'contact.preferred_email',
            'contact.company_name',
            'contact.profile_image'
        ];
    }

    _getDisplayStoreSort() {
        return {
            'contact.full_name': 'asc'
        };
    }

    _prepareSpecialFilterInformation() {

        this.specialFilterInformation = [
            {
                label: 'Guestlist',
                value: this.guestlist ? this.guestlist.name : 'Masterlist'
            }
        ]
    }

    _collectExtendedMessageParameters() {
        const out = super._collectExtendedMessageParameters();

        if (this.guestlist && this.guestlist.ticket_template_id) {
            out.push({
                key: 'attach_ticket',
                label: 'Attach Ticket:',
                default: false
            });
        }

        if (this.guestlist && this.guestlist.passbook_id) {
            out.push({
                key: 'attach_passbook',
                label: 'Attach Wallet:',
                default: (
                    _.get(this.guestlist, 'settings.attach_passbook_to_confirmation_email', false)
                    && _.filter(
                        this.guestlist.templates,
                        (glTemplate) => {
                            return glTemplate.status === 'confirmed' && glTemplate.template_id === parseInt(this.selectedTemplateId);
                        }).length > 0
                )
            });
        }

        return out;
    }

    _prepareRecipientPostData() {
        return {
            recipient_type: 'rsvp',
            rsvps: this.recipientsStore.getters.selectedFilters
        }
    }

    _getPreviewUrl(recipient) {
        return `templates/${this.selectedTemplateId}/preview/rsvp/${recipient.id}`;
    }

    _updatePreviewAttachments() {
        super._updatePreviewAttachments();

        if (!this.previewData) {
            return;
        }

        if (
            this.extendedMessageParameterModels.attach_passbook
            && this.previewData.passbook
        ) {
            const passbook = this.previewData.passbook;

            this.previewAttachments.push({
                name: passbook.passbook_label,
                action: () => {
                    this.api
                        .post(
                            `passbooks/${passbook.passbook_id}/download`,
                            {
                                id: this.guestlist,
                                rsvp_id: this.recipientsToDisplay[this.selectedDisplayIndex].id,
                                type: 'rsvp'
                            },
                            {responseType: "blob"}
                        )
                        .then(({data, headers}) => {
                            this.fileSaver.saveAs(
                                new Blob([data], {type: headers('content-type')}),
                                passbook.passbook_label
                            );
                        })
                }
            });
        }

        if (
            this.extendedMessageParameterModels.attach_ticket
            && this.previewData.tickets
        ) {
            _.each(this.previewData.tickets, (ticketInformation) => {
                this.previewAttachments.push({
                    name: ticketInformation.file.name,
                    action: () => {
                        this.api
                            .get(
                                ticketInformation.file.url,
                                {responseType: "blob"}
                            )
                            .then(({data, headers}) => {
                                this.fileSaver.saveAs(
                                    new Blob([data], {type: headers('content-type')}),
                                    ticketInformation.file.name
                                );
                            })
                    }
                });
            });
        }
    }

    _handleEmptyTemplates() {
        this.modalInstance.dismiss();

        this.alert
            .animatedAlert(
                this.translate.instant('messages.controllers.rsvp-message-modal.no-templates-available.title'),
                this.translate.instant('messages.controllers.rsvp-message-modal.no-templates-available.content'),
                'attention',
                {
                    confirmButtonText: this.translate.instant('messages.controllers.rsvp-message-modal.no-templates-available.add_template'),
                    cancelButtonText: this.translate.instant('general.buttons.cancel'),
                    confirmButtonColor: '#e01249'
                }
            )
            .then(() => {
                if (this.guestlist) {
                    this.state.go('app.guestlists.rsvps.messages.templates', {
                        gid: this.guestlist.id
                    });
                } else {
                    this.state.go('app.templates.index', {
                        startTab: 'shared'
                    });
                }
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/messages/controllers/modals/bulk-send/rsvp-bulk-message-modal.js